<app-clue-list [readonly]="readonly" [gameStepClues]="gameStepClues" (addClueEvent)="addClue($event)"
               (removeClueEvent)="removeClue($event)" (updateClueEvent)="updateClue($event)">
